import AppConfig from "config";
import GetIpController from "components/GetIp/GetIp";
import axios from "axios";

const LoginController = {
  async Login(login, password) {
    try {
      // const ip = await GetIpController.GetIpUser();
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO+"login_page/login", {
        login: login,
        password: password,
        ip: null,
      });
      return response.data;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  },
};

export default LoginController;